<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id" />
      </a-form-model-item>
      <a-form-model-item label="是否私人模式" prop="isPrivate" >
        <a-input v-model="form.isPrivate" placeholder="请输入是否私人模式" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测尿酸值(微摩尔/升)" prop="bloodUricAcid" >
        <a-input v-model="form.bloodUricAcid" placeholder="请输入血液成分检测尿酸值(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测总胆固醇值(微摩尔/升)" prop="bloodCholesterol" >
        <a-input v-model="form.bloodCholesterol" placeholder="请输入血液成分检测总胆固醇值(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测甘油三酯值(微摩尔/升)" prop="bloodTriglyceride" >
        <a-input v-model="form.bloodTriglyceride" placeholder="请输入血液成分检测甘油三酯值(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测高密度脂蛋白(微摩尔/升)" prop="bloodHighLipoprotein" >
        <a-input v-model="form.bloodHighLipoprotein" placeholder="请输入血液成分检测高密度脂蛋白(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="血液成分检测低密度脂蛋白(微摩尔/升)" prop="bloodLowLipoprotein" >
        <a-input v-model="form.bloodLowLipoprotein" placeholder="请输入血液成分检测低密度脂蛋白(微摩尔/升)" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBloodComponents, addBloodComponents, updateBloodComponents } from '@/api/joe/bloodComponents'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        isPrivate: null,

        bloodUricAcid: null,

        bloodCholesterol: null,

        bloodTriglyceride: null,

        bloodHighLipoprotein: null,

        bloodLowLipoprotein: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        isPrivate: null,
        bloodUricAcid: null,
        bloodCholesterol: null,
        bloodTriglyceride: null,
        bloodHighLipoprotein: null,
        bloodLowLipoprotein: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBloodComponents({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBloodComponents(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBloodComponents(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
